import { render, staticRenderFns } from "./LiquidationAdd.vue?vue&type=template&id=2089b61a&scoped=true"
import script from "./LiquidationAdd.vue?vue&type=script&lang=js"
export * from "./LiquidationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089b61a",
  null
  
)

export default component.exports